var map = {
	"./awesome.gif": "7581",
	"./candle.gif": "9395",
	"./cool.gif": "cb92",
	"./cry.gif": "e254",
	"./emmm.gif": "4ba2",
	"./favour.gif": "b64d",
	"./great.gif": "6d73",
	"./haha.gif": "d5a1",
	"./happy.gif": "c2f2",
	"./hum.gif": "fbec",
	"./kiss.gif": "f646",
	"./laugh&cry.gif": "fd84",
	"./like.gif": "62b7",
	"./love.gif": "6c4f",
	"./pray.gif": "cded",
	"./sad.gif": "2220",
	"./shy.gif": "8a0a",
	"./silly.gif": "6891",
	"./weixiao.gif": "309d",
	"./xixi.gif": "a389"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79e9";